import { css } from '@emotion/react';

export const dobTextStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @container submission-details-view (max-width: 850px) {
    max-width: 40px;
  }
`;
